import { forwardRef, useRef } from "react";
import NumberInput from "@/components/ui/NumberInput";

/**
 * Input numérico para montos/precios/cantidades con separador de miles.
 *   - onFocus: si value es 0/"0"/"0.00", limpia el input (queda vacío).
 *   - Si el value no es 0, hace select() para reemplazo directo al tipear.
 */
const MoneyInput = forwardRef(function MoneyInput(
  { value, onChange, onFocus, step = "0.01", ...rest },
  ref
) {
  const innerRef = useRef(null);
  const setRef = (el) => {
    innerRef.current = el;
    if (typeof ref === "function") ref(el);
    else if (ref) ref.current = el;
  };

  const handleFocus = (e) => {
    const v = String(value ?? "").trim();
    const num = parseFloat(v.replace(",", "."));
    if (v === "" || (!isNaN(num) && num === 0)) {
      onChange?.({ ...e, target: { ...e.target, value: "" } });
    } else {
      setTimeout(() => {
        try { innerRef.current?.select(); } catch (_) {}
      }, 0);
    }
    onFocus?.(e);
  };

  return (
    <NumberInput
      ref={setRef}
      value={value}
      step={step}
      onChange={onChange}
      onFocus={handleFocus}
      {...rest}
    />
  );
});

export default MoneyInput;
